module.exports = __webpack_public_path__ + "static/media/pic22.7b777554.jpeg";